import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const links: readonly Readonly<PageLinkModel>[] | undefined = state.links.pageLinks?.find(
        pLink => pLink.type === "HomePage",
    )?.children;

    const articleLink = links?.find(pLink => pLink.url === "/Articles");

    return {
        articleLink,
    };
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface CENSiteMapArticlesStyles {
    wrapper?: InjectableCss;
    heading?: TypographyPresentationProps;
    link?: LinkPresentationProps;
}

export const siteMapArticlesStyles: CENSiteMapArticlesStyles = {
    heading: {
        css: css`
            text-align: center;
            font-size: 2rem;
            font-family: "Poppins";
        `,
    },
    link: {
        css: css`
            padding: 5px;
        `,
    },
};

const styles = siteMapArticlesStyles;

export const UnorderedList = styled.ul<InjectableCss>`
    column-count: 4;
    display: block;
    padding: 10px 30px;
    border-radius: 0;
    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
                column-count: 1;
            `,
            css`
                column-count: 2;
            `,
            css`
                column-count: 3;
            `,
            css`
                column-count: 4;
            `,
            css`
                column-count: 4;
            `,
        ])}
    ${injectCss}
`;

const ListItem = styled.li`
    list-style: none;
`;

export const CENSiteMapArticles: FC<Props> = ({ fields, articleLink }) => {
    const hasArticles = articleLink?.children && articleLink.children.length > 0;

    if (!hasArticles) {
        return null;
    }

    return (
        <StyledWrapper>
            <Typography as="h2" {...styles.heading}>
                {translate("Articles")}
            </Typography>

            <UnorderedList>
                {articleLink.children.map(pLink => (
                    <ListItem key={pLink.id}>
                        <Link href={pLink.url} {...styles.link}>
                            {pLink.title}
                        </Link>
                    </ListItem>
                ))}
            </UnorderedList>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CENSiteMapArticles),
    definition: {
        group: "Common",
    },
};

export default widgetModule;
